import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";

type AuthorProps = {
  photo: string;
  name: string;
  label: string;
};

export default function Author({ photo, name, label }: AuthorProps) {
  return (
    <div sx={authorStyle}>
      <img sx={authorPhotoStyle} src={photo} alt="" />
      {false && <div sx={authorLabelStyle}>{label}</div>}
      <div sx={authorNameStyle}>{name}</div>
    </div>
  );
}

const authorStyle: ThemeUIStyleObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};

const authorLabelStyle: ThemeUIStyleObject = {
  fontSize: "12px",
  fontWeight: "300",
  color: "dt_content_tertiary",
};

const authorNameStyle: ThemeUIStyleObject = {
  fontSize: "16px",
  fontWeight: "600",
  color: "dt_content_primary",
  marginLeft: RAW_cssValue("10px"),
  marginRight: RAW_cssValue("10px"),
};

const authorPhotoStyle: ThemeUIStyleObject = {
  maxWidth: "23px",
  maxHeight: "23px",
  width: "23px",
  height: "23px",
  borderRadius: "dt_radius_s",
};
